






import { Component, Vue } from 'vue-property-decorator'

@Component
export default class InfoBox extends Vue {}
